import { getAccessToken } from "~/Services/Authentication";

export const downloadSystemFile = (path: string) => {
    const form = document.createElement("form");
    form.method = "POST";
    form.action = `/api/v1/admin/systemFiles/content?path=${path}&useJwtToken=true`;
    form.style.display = "none";
    form.target = "_blank";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "jwtToken";
    let accessToken = getAccessToken();
    if (!accessToken) {
        throw new Error("User is not signed in.");
    }
    input.value = accessToken;
    form.appendChild(input);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};
